var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46443 4.05022C5.07391 3.65969 4.44074 3.65969 4.05022 4.05022C3.65969 4.44074 3.65969 5.07391 4.05022 5.46443L10.5858 12L4.05022 18.5355C3.65969 18.926 3.65969 19.5592 4.05022 19.9497C4.44074 20.3402 5.07391 20.3402 5.46443 19.9497L12 13.4142L18.5355 19.9497C18.926 20.3402 19.5592 20.3402 19.9497 19.9497C20.3402 19.5592 20.3402 18.926 19.9497 18.5355L13.4142 12L19.9497 5.46443C20.3402 5.07391 20.3402 4.44074 19.9497 4.05022C19.5592 3.65969 18.926 3.65969 18.5355 4.05022L12 10.5858L5.46443 4.05022Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.5554bb6baf44463bffde425239311716.svg";
export { ForwardRef as ReactComponent };